<template>
  <v-container fluid>
    <v-dialog v-model="pdfDialogDownload" max-width="400">
      <v-card>
        <v-card-title class="headline">Salvar Arquivo</v-card-title>
        <v-card-text>
          Clique abaixo para salvar o arquivo.<br />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <a :href="pdfFileLink" download>
            <v-btn color="success" text @click="pdfDialogDownload = false">
              Salvar Arquivo
            </v-btn>
          </a>
          <v-btn color="error" text @click="pdfDialogDownload = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <FormReport :title="'Relatório de Alertas'" 
      :main_headers="main_headers" 
      :secondary_headers="secondary_headers"
      :select_id="catch_id"
      :data_table_prop="data_table" 
      :data_table_expand_prop="data_table_expand"
      :show_expand_prop="show_expand" 
      :onExpand_prop="onExpand"
      :getAlertsPerData="getAlertsPerData"
      :activate_pdf_button="false"
      :generatePdf="generatePdf"
      :start_view_date="startDatePicker"
      >
      
      <table style="
        border-radius: 5px;
        border-collapse: collapse;
        width: 100%;
        overflow: hidden;
        height: 85%;
      "
      v-if="data_table && data_table.length > 0"
      slot="summary-header"
      >
        <caption class="TitleChecklist" style="background: #0a517f; color: white">
          <strong> Resumo </strong>
        </caption>
        <tr>
          <td class="TitleChecklist column-statitcs-info" style="background: #056aae; color: white">
            Alertas: <strong>{{ summary.size }}</strong>
          </td>
          <td class="TitleChecklist column-statitcs-info" style="background: #0e76bc; color: white">
            Meta Excedida: <strong>{{ summary.goal_exceeded }}</strong>
          </td>
          <td class="TitleChecklist column-statitcs-info" style="background: #0e76bc; color: white">
            Meta Agendada: <strong>{{ summary.goal_scheduled }}</strong>
          </td>
          <td class="TitleChecklist column-statitcs-info" style="background: #056aae; color: white">
            Consumo: <strong>{{ summary.consumption }}</strong>
          </td>
          <td class="TitleChecklist column-statitcs-info" style="background: #0e76bc; color: white">
            Telemetria: <strong>{{ summary.telemetry }}</strong>
          </td>
          <td class="TitleChecklist column-statitcs-info" style="background: #056aae; color: white">
            Reservatório: <strong>{{ summary.reservoir }}</strong>
          </td>
        </tr>

      </table>
      <template v-slot:button-main-table="{onClick,prop,disabled,loading,status}">
          <v-menu  offset-y >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                v-bind="attrs"
                v-on="on"
                color="primary"
                style="font-weight: bold"
                outlined       
                :disabled="disabled(prop)"
                :loading="loading(prop)"                       
                
              >
                <v-icon small >
                  mdi-text-box-multiple-outline
                </v-icon>
              </v-btn>
            </template>
            <v-list >
                <v-list-item
                  link
                  v-for="(line, index) in titles_button_download"
                  :key="index"
                  :value="index"
                >
                  <v-list-item-title  @click="catch_report_tipe(line.title,onClick,prop,status)">{{ line.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
        </template>
      </FormReport>
      <DialogSendEmail :open="dialog_send_email" :runFunc="sendEmail"/>
  </v-container>
</template>

<script>
import ReportScript from "./ReportScript";
export default ReportScript;
</script>

<style ></style>